import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService } from '../../../services/auth.service';
import { AuthSessionService } from '../../../services/auth-session.service';
import * as LoginActions from './actions';
import { catchError, exhaustMap, map, of, tap } from 'rxjs';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class LoginEffects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);
  private authSessionService = inject(AuthSessionService);
  private router = inject(Router);
  private snackbar = inject(MatSnackBar);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoginActions.login),
      exhaustMap((action) =>
        this.authService.login(action.user, action.password).pipe(
          map((response) => LoginActions.loginSuccess(response)),
          catchError((error: HttpErrorResponse) =>
            of(LoginActions.loginError({ error: error }))
          )
        )
      )
    )
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginActions.loginSuccess),
        tap(() => {
          const redirectTo = this.authSessionService.consumeRedirectUrl();
          if (redirectTo) {
            this.router.navigateByUrl(redirectTo);
          } else {
            this.router.navigate(['/home']);
          }
        })
      ),
    { dispatch: false }
  );

  loginError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginActions.loginError),
        tap((action) => {
          if (action.error.status == 401) {
            this.snackbar.open('Credenciales inválidas');
            return;
          }

          this.snackbar.open('Ocurrió un error al procesar la solicitud');
        })
      ),
    { dispatch: false }
  );
}
